<template>
  <div>
    <!-- 参数管理 -->
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @addSubmit="addSubmit"
      @etidSubmit="etidSubmit"
      @refreshBtn="refreshBtn"
    ></zx-table>
  </div>
</template>
<script>
import * as config from "@/api/config/config.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "参数",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: true,
        // 编辑 默认:true;
        editBtn: true,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "config_name",
            label: "参数名称",
            nowrap: true,
            type: "input",
            hide: true
          },
          {
            prop: "config_key",
            label: "参数键名",
            type: "input",
            hide: true
          },
          {
            prop: "config_value",
            label: "参数值",
            nowrap: true,
            type: "input",
            hide: true
            // 该字段是否可以在创建时编辑 默认:true;
            // addDisplay: false,
            // 该字段是否可以修改默认true
            // editDisplay: false
          },
          {
            prop: "config_type",
            label: "状态",
            type: "radio",
            show: "tag",
            default: 0,
            options: [
              {
                text: "是",
                value: "Y"
              },
              {
                text: "否",
                value: "N"
              }
            ],
            tagtype: [
              {
                text: "是",
                type: "success",
                value: "Y"
              },
              {
                text: "否",
                type: "danger",
                value: "N"
              }
            ],
            hide: true
          },
          {
            prop: "remark",
            label: "备注",
            type: "textarea",
            nowrap: true,
            hide: true
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    // 添加提交
    addSubmit(form) {
      form["menu_ids"] = [];
      config.addConfig.r(form).then(res => {
        this.$message.success("账号" + res.role_name + "创建成功");
        this.getlist();
      });
    },
    // 编辑
    etidSubmit(form) {
      config.etidConfig.r(form).then(res => {
        if (res.status) this.$message.success("修改成功");
        else this.$message.success("修改失败");
        this.getlist();
      });
    },
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          config.deleteConfig.r({ config_id: form.config_id }).then(res => {
            console.log("成功");
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      config.getConfigList.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
